import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { getStore } from '../store/index.mjs';
import { StoreInit } from '../store/init/index.mjs';

function FlowbiteIcons({ children, ...props }) {
  const prevTheme = getStore();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(StoreInit, { ...props }),
    children,
    /* @__PURE__ */ jsx(StoreInit, { ...prevTheme, override: true })
  ] });
}

export { FlowbiteIcons };
//# sourceMappingURL=provider.mjs.map
